export default __webpack_public_path__ + "static/img17-12fca2b333f5ae28c90b52bc9b96e7dd.png";